import { Spacer, Text } from '@sparemin/blockhead';
import React from 'react';
import { block } from './utils';

export type AccordionHeaderProps = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  isExpanded?: boolean;
};

const AccordionHeader: React.FC<AccordionHeaderProps> = ({
  title,
  description,
  isExpanded,
}) => {
  return (
    <Spacer
      space="4px"
      orientation="vertical"
      align="flex-start"
      justify="center"
      className={block('header')}
    >
      <Text variant="label" lineHeight="1.3" className={block('title')}>
        {title}
      </Text>

      {description && isExpanded && (
        <Text
          variant="label"
          weight="400"
          lineHeight="1.3"
          className={block('description')}
        >
          {description}
        </Text>
      )}
    </Spacer>
  );
};

export default AccordionHeader;
